import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchPointLogs = createAsyncThunk(
  "pointLogs/fetchPointLogs",
  async () => {
    const response = await apiCustom.get("point-log-show");
    return response.data?.data?.data;
  }
);

const pointLogsSlice = createSlice({
  name: "pointLogs",
  initialState: {
    pointLogs: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPointLogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPointLogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pointLogs = action.payload;
      })
      .addCase(fetchPointLogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default pointLogsSlice.reducer;
